import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=9ee935a0&scoped=true&"
import script from "./receipt.vue?vue&type=script&lang=js&"
export * from "./receipt.vue?vue&type=script&lang=js&"
import style0 from "./receipt.vue?vue&type=style&index=0&id=9ee935a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee935a0",
  null
  
)

component.options.__file = "receipt.vue"
export default component.exports